<template>
  <div>

      <v-container style="border-bottom_: 1px solid orange;">
        <v-row >
          <v-col class="col-sm-12 col-md-7">
            <div class="display-1">{{ $t('inicioNombreParking') }}</div>
            <div class="subtitle-1">{{ $t('presentacionPubli') }}</div>

            <v-container>
              <v-row style="border-bottom: 1px solid #e4e4e4;">
                <v-col class="col-sm-2 pl-0" style="color: #4894ef">{{ $t('presentacionDireccion') }}</v-col>
                <v-col
                  class="col-sm-10"
                > {{ $t('presentacionDireccionParking') }} </v-col>
              </v-row>

              <v-row style="border-bottom: 1px solid #e4e4e4;">
                <v-col class="col-sm-2 pl-0" style="color: #4894ef">{{ $t('presentacionHorario') }}</v-col>
                <v-col class="col-sm-10">
                  <strong>{{ $t('presentacionAccesos') }}</strong>
                  <br />{{ $t('presentacionDias') }}
                </v-col>
              </v-row>


              <!-- tabla de servicios y características del parking -->
              <v-container class="pa-0 ma-0" >
                <v-row align="stretch" justify="center" class="pa-0">
                  <v-col class="col-md-4 col-sm-12 columna d-flex" style="flex-direction:column" v-for="(servicio, index) in serviciosParking" :key="index">

                      <div class="tarjeta flex-grow-1" align="center" justify="center" width="100%">
                        <v-img height="50" :contain="true"
                              :src="require(`@/assets/servicios/${servicio.icono}`)">
                        </v-img>

                        <v-row class="infoAdicionaltarjeta" align="center" justify="center" style="padding: 10px;">
                          {{ $t(servicio.texto) }}
                        </v-row>       
                      </div> 

                  </v-col>   
                </v-row>

                <v-row align="center" justify="center" class="subtitle-1 font-weight-bold"
                    style="color: white; background: #1ab9e4;" >
                  <v-col align="center" justify="center">
                    {{ $t("servicioCancelacionReserva") }}
                  </v-col>   
                </v-row>  
              </v-container>

            </v-container>
          </v-col>

          <v-col class="col-sm-12 col-md-5">
            <v-img src="@/assets/mapa-parking-cruceros-barcelona.jpg"></v-img>
            <v-carousel class="mt-2" cycle height="315" style="max-height: 315px">
              <v-carousel-item src="@/assets/c1.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c2.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c3.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c4.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c5.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c6.jpg"></v-carousel-item>
              <v-carousel-item src="@/assets/c7.jpg"></v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
      </v-container>



      <v-container style="background-color: #EEEEEE; border-bottom_: 1px solid orange">
        <v-row >
          <v-col class="col-sm-12 col-md-7">

            <!-- media fila izq. TablaTarifa -->

            <template v-if="tarifaParking.hayTarifa == true"> 
              <v-simple-table style="border: 2px solid orange;">
                <template>
                  <thead><label style="margin:20px; color: #4894ef;">{{ $t('tablaTarifaTitulo') }}</label>
                    <tr> 
                      <th class="text-right" style="background-color: #3489ff; color: white; font-size: 16px;"   >{{ $t('tablaTarifaDias') }}</th>
                      <th class="text-left" width="50%" style="background-color: #3489ff; color: white; font-size: 16px;">{{ $t('tablaTarifaPrecio1') }}<br>{{ $t('tablaTarifaPrecio2') }} </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tarifaDiaria, index) in tarifaParking.tarifa" :key="index">
                      <td class="text-right">{{ cadenaDuracion(index) }}</td>
                      <td class="text-left">{{ tarifaDiaria.printable_total_amount }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
            <template v-else> 
              <p>No he recibido la tarifa!!!</p> 
            </template>

            <template v-if="tarifaParkingHoras.hayTarifa == true"> 
              <v-simple-table style="border: 2px solid orange; margin-top: 5px;">
                <template>
                  <thead><label style="margin:20px; color: #4894ef;">{{ $t('tablaTarifaHorasTitulo') }}</label>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-right" width="50%" style="font-size:16px;">{{ $t('tablaTarifaHoras') }}</td>
                      <td class="text-left">{{ tarifaParkingHoras.tarifa[0].printable_total_amount }}</td>
                    </tr>
                    <tr>
                      <td class="text-right" width="50%" style="font-size:16px;">{{ $t('tablaTarifaDiaPorHoras') }}</td>
                      <td class="text-left">{{ tarifaParkingDiaPorHoras.tarifa[23].printable_total_amount }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </template>
            <template v-else> 
              <p>No he recibido la tarifa!!!</p> 
            </template>

          </v-col>


          <v-col class="col-sm-12 col-md-5">
            <!-- media fila der. Formulario reserva -->

              <div class="subtitle-1_" style="background: #4894ef; color: white;">
                <label style="margin:20px;">{{ $t('datosReservaTitulo') }}</label>

                <form @submit.prevent="">
                    <div class="form-group entradaDatosVarios" >
                      <label style="margin-bottom: 0px;" for="fechaEntrada">{{ $t('datosReservaFechaEntrada') }}</label>
      
                      <v-row>
                        <v-col cols="auto">                      
                          <div style="width: 260px; height: 40px; background-color:white; color: black; border-radius: 4px;">
                            <v-row align="center" justify="start" style="padding-top:7px; padding-left: 7px;">  

                              <font-awesome-icon 
                                style="background-color: transparent; margin-left: 18px; margin-right: 5px"
                                @click="abrirSelectorFechaEntrada()" 
                                class="iconoPicker fa-flip-horizontal" :icon="['fas', 'calendar']"
                              />           
                            
                              <datepicker ref="fechaEntrada" id="fechaEntrada" name="fechaEntrada" 
                                          class="form-control_" 
                                          v-model="datosReserva.fechaEntrada"   
                                          :class="{ 'is-invalid': submitted && $v.datosReserva.fechaEntrada.$error }"
                                          @input="this.calcularImporteEstancia"
                                          :language="this.establecerIdiomaDatepicker()" 
                                          :required="true"
                                          :monday-first="true"
                                          :disabled-dates="this.fechaMinimaEntrada"
                                          :value="datosReserva.fechaEntrada"
                              />
                            </v-row>
                            
                            <div v-if="submitted && !$v.datosReserva.fechaEntrada.required" class="invalid-feedback">
                              {{ $t('errorNoFechaEntrada') }}
                            </div> 
                            
                          </div>
                        </v-col>                   

                        <v-col cols= "auto">
                          <div style="width: 205px; height: 40px; background-color:white; color: black; border-radius: 4px;">
                            
                            <v-row align="center" justify="start" style="padding-top:3px; padding-left: 7px;">  

                              <font-awesome-icon 
                                style="background-color: transparent; margin-left: 18px; margin-right: 5px"
                                @click="abrirSelectorHoraEntrada()" 
                                class="iconoPicker fa-flip-horizontal" :icon="['fas', 'clock']"
                              />           
                            
                            
                              <vue-timepicker ref="horaEntrada" id="horaEntrada" name="horaEntrada"
                                style="border_: 1px solid #ddd;"
                                v-model="datosReserva.horaEntrada"              
                                @input="this.calcularImporteEstancia"
                                :minute-interval="5" 
                                format="HH:mm"
                                close-on-complete_ 
                                hide-clear-button 
                                auto-scroll ></vue-timepicker> 
                            
                            </v-row>
                          </div>    
                        </v-col>  
                      </v-row>
                    </div>


                    <div class="form-group entradaDatosVarios" >
                      <label style="margin-bottom: 0px;" for="fechaSalida">{{ $t('datosReservaFechaSalida') }}</label>
      
                     <v-row>
                        <v-col cols="auto">                      
                          <div style="width: 260px; height: 40px; background-color:white; color: black; border-radius: 4px;">
                            <v-row align="center" justify="start" style="padding-top:7px; padding-left: 7px;">  

                              <font-awesome-icon 
                                style="background-color: transparent; margin-left: 18px; margin-right: 5px"
                                @click="abrirSelectorFechaSalida()" 
                                class="iconoPicker fa-flip-horizontal" :icon="['fas', 'calendar']"
                              />           

                              <datepicker ref="fechaSalida" id="fechaSalida" name="fechaSalida" class="form-control_"
                                          v-model="datosReserva.fechaSalida"   
                                          :class="{ 'is-invalid': submitted && $v.datosReserva.fechaSalida.$error }"
                                          @input="this.calcularImporteEstancia"
                                          :language="this.establecerIdiomaDatepicker()" 
                                          :required="true"
                                          :monday-first="true"
                                          :disabled-dates="this.fechaMaximaSalida"
                                          :value="datosReserva.fechaSalida"
                                          />
                            </v-row>

                            <div v-if="submitted && !$v.datosReserva.fechaSalida.required" class="invalid-feedback">
                              {{ $t('errorNoFechaSalida') }}
                            </div> 
                          </div>
                        </v-col>                   

                        <v-col cols= "auto">
                          <div style="width: 205px; height: 40px; background-color:white; color: black; border-radius: 4px;">
                            
                            <v-row align="center" justify="start" style="padding-top:3px; padding-left: 7px;">  

                              <font-awesome-icon 
                                style="background-color: transparent; margin-left: 18px; margin-right: 5px"
                                @click="abrirSelectorHoraSalida()" 
                                class="iconoPicker fa-flip-horizontal" :icon="['fas', 'clock']"
                              />           
                            
                            <vue-timepicker ref="horaSalida" id="horaSalida" name="horaSalida"
                              v-model="datosReserva.horaSalida"              
                              @input="this.calcularImporteEstancia"
                              :minute-interval="5" 
                              format="HH:mm"
                              close-on-complete_ 
                              hide-clear-button 
                              auto-scroll ></vue-timepicker> 
                            </v-row>
                          </div>    
                        </v-col>  
                      </v-row>
                    </div>


                    <div class="form-group entradaDatosUnico">
                        <v-alert style="margin-bottom:10px;"
                              :value="alerta.mostrar"
                              color="pink"
                              dark
                              border="top"
                              icon="mdi-home"
                              transition="scale-transition"
                        >
                          {{ this.alerta.texto }}
                        </v-alert> <!-- para mostrar mensaje de error de fechas -->

                    </div>

                    <div class="entradaDatosImporte1">
                        <label>{{ $t('datosReservaPrecioTotal') }}</label> 
                        <label class="importe1">{{datosReserva.importeReserva}}</label>
                    </div>

                    <div class="form-group entradaDatosUnico">
                        <label for="matricula">{{ $t('datosReservaMatricula') }}</label>
                        <input type="text" v-model="datosReserva.matricula" id="matricula" name="matricula" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.matricula.$error }" />
                        <div v-if="submitted && !$v.datosReserva.matricula.required" class="invalid-feedback">
                          {{ $t('errorNoMatricula') }}
                        </div>
                        <div v-if="submitted && !$v.datosReserva.matricula.alphaNum" class="invalid-feedback">
                          {{ $t('errorCaracteresMatricula') }}
                        </div>                    
                    </div>

                    <div class="form-group entradaDatosUnico">
                        <label for="modelo">{{ $t('datosReservaModelo') }}</label>
                        <input type="text" v-model="datosReserva.modelo" id="modelo" name="modelo" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.modelo.$error }" />
                        <div v-if="submitted && !$v.datosReserva.modelo.required" class="invalid-feedback">
                          {{ $t('errorNoModelo') }}
                        </div>
                    </div>
          
                    <div class="form-group entradaDatosUnico">
                      <label for="crucero">{{ $t('datosReservaCrucero') }}</label>
                      <v-combobox
                            id="crucero"
                            :items="cruceros"
                            item-text="nombre"
                            :return-object="false"
                            class="form-control"
                            v-model="datosReserva.crucero"   
                            :class="{ 'is-invalid': submitted && $v.datosReserva.crucero.$error }"                                          
                            :outlined="false"
                            style="padding-top: 0px; padding-left: 2%; padding-right: 10%"
                          >
                      </v-combobox>
                      <div v-if="submitted && !$v.datosReserva.crucero.required" class="invalid-feedback">
                        {{ $t('errorNoCrucero') }}
                      </div> 
                    </div>

                    <div class="form-group entradaDatosUnico" style="border-top: 1px solid rgb(100, 100, 180);">
                        <label for="color">{{ $t('datosReservaColor') }}</label>
                        <input type="text" v-model="datosReserva.color" id="color" name="color" class="form-control" :class="{ 'is-invalid': submitted && $v.datosReserva.color.$error }" />
                        <div v-if="submitted && !$v.datosReserva.color.required" class="invalid-feedback">
                        {{ $t('errorNoColor') }}
                        </div>
                    </div>

                    <div class="entradaDatosImporte2">
                      <div style="border-bottom: 1px solid rgb(100, 100, 180);">
                        <v-row align="center" justify="center">
                          <v-col align="start">
                          <label>{{ $t('datosReservaPrecioTotal') }}</label> 
                          </v-col>

                          <v-col align="end">  
                            <label>{{datosReserva.importeReserva}}</label> 
                          </v-col>
                        </v-row>
                      </div>

                      <div>
                        <v-row align="center" justify="center">
                          <v-col align="start">
                          <label class="importeTotalFinalTitulo">{{ $t('datosReservaTotal') }}</label> 
                          </v-col>

                          <v-col align="end">  
                            <label class="importeTotalFinal">{{datosReserva.importeReserva}}</label> 
                          </v-col>
                        </v-row>
                      </div>


                      <div>
                        <v-alert style="margin-bottom:10px;"
                              :value="alertaDisponibilidad.mostrar"
                              color="pink"
                              dark
                              border="top"
                              icon="mdi-home"
                              transition="scale-transition"
                        >
                          {{ this.alertaDisponibilidad.texto }}
                        </v-alert> <!-- para mostrar mensaje de error de comunicaciones/disponibilidad -->
                      </div>

                      <div>
                        <v-alert style="margin-bottom:10px;"
                              :value="alertaTarifa.mostrar"
                              color="pink"
                              dark
                              border="top"
                              icon="mdi-home"
                              transition="scale-transition"
                        >
                          {{ this.$t('errorObteniendoTarifa') }}
                        </v-alert> <!-- para mostrar mensaje de error de comunicaciones/disponibilidad -->
                      </div>

                      <div class="form-group">

                        <v-overlay v-model="dialog">
                          <v-progress-circular  
                            size="120"
                            width="12"                       
                            color="red"
                            indeterminate
                            justify="center" 
                            align="center">
                          </v-progress-circular>
                        </v-overlay> <!-- indicador de espera para la obtencion de disponibilidad de plazas -->

                        <v-btn
                          class="mx-auto white--text boton-hacerReserva"
                          color="#f08823"
                          @click="handleSubmit()"
                        >
                          {{ $t('btnReservar') }}
                        </v-btn>

                      </div>

                    </div>

                </form> <!-- fin formulario datos reserva -->
          
              </div> <!-- fin titulo Completa tu reserva -->

          </v-col>

        </v-row>
      </v-container>

  
  </div> 
</template>


<style scoped>
/* ATENCION: 
  No se puede cambiar directamente los estilos del timepicker; así que he alterado el archivo
  'vue2-timepicker/dist/VueTimepicker.css' para que el color con el que se indica la seleccion 
  de una hora/minuto sea el mismo que en el datepicker; tambien para que no aparezca un borde 
  alrededor de la hora */


/* con esto consigo el cambio de color en cada una de las lineas de la tabla */
  table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #ddd;
  }

  th, td {
    text-align: left;
    padding: 10px;
  }

  tr:nth-child(odd) {
    background-color: #eeeeee;
    border-left_: 1px solid #000000;
  }

/* esto elimina el efecto de resaltar las lineas de la tabla segun 
  muevo el raton sobre ellas (hover) */
  tr:nth-child(odd):hover {
    background-color:  #eeeeee !important;
    border-left: 1px solid orange;
  }

  tr:nth-child(even):hover {
    background-color:  #ffffff !important;
    border-left_: 1px solid orange;
  }


/* Datos de reserva */
  .entradaDatosVarios {
    margin-left: 20px;
  }

  .entradaDatosUnico {
    margin-left: 20px;
    margin-right: 20px;
  }

  .entradaDatosImporte1 {
    background-color: royalblue;
    padding-left:20px;
    padding-top:20px;
    padding-bottom: 10px;
    margin-bottom:10px;
  }

  .entradaDatosImporte2 {
    background-color: black;
    color: white;
    padding-left:20px;
    padding-top:10px;
    padding-right: 20px;
    padding-bottom: 10px;
    margin-bottom:10px;
  }

  .importe1 {
    margin-left: 10px;
    font-size: 25px;
  }

  .boton-hacerReserva {
    width: 100%; 
    background-color: orange; 
    color: white; 
    font-size: 22px; 
    border-color: orange;
  }

  .importeTotalFinal{
    font-size: 30px;
    font-weight: bold;
    color: skyblue;
  }

  .importeTotalFinalTitulo{
    font-size: 25px;
    font-weight: bold;
  }


/* Tarjetas de puntos de interes */
  .columna {
    padding: 0px;
    margin-bottom: 0px;
	}

  .tarjeta {
    border-top: 1px solid rgb(240, 220, 220);
    border-bottom: 1px solid rgb(240, 220, 220);
    border-left: 1px solid rgb(240, 220, 220);
    border-right: 1px solid rgb(240, 220, 220);
    padding: 10px;
    margin: 0px;
	}

  .iconoTituloArea{
    font-size:25px;
    color:#1A55F4; 
    margin-right: 10px;
  }

  .iconoPicker{
    font-size:25px;
    color:#1A55F4; 
    margin: 0px;
  }

  .iconoEnTarjeta{
    font-size:15px;
    color:#1A55F4; 
    margin-right: 8px;
  }

  .infoAdicionaltarjeta {
    margin-top: 5px;
    font-size: 12px;
    color: rgb(128,128,128);
  }

</style>


<script>
// comunicacion HTTP con RestApi
import axios from "axios"

// constantes para todo el proyecto
import { escribirLog, generarUrlBase, codinsclo } from '@/plugins/utilidades.js'

// validacion de formularios
import { required, alphaNum /*, minLength, sameAs */} from "vuelidate/lib/validators";

// traducciones para el datepicker
import {es, fr, en, ca} from 'vuejs-datepicker/dist/locale';

export default {
  name: "PaginaReservar",
  optionsDatepicker: {

                    icons: {

                        date: 'far fa-calendar',
                        calendar: 'far fa-calendar',

                    }
                },

  data: () => ({
    serviciosParking: [
      { icono: 'airelibre.png',
        texto: 'servicioAireLibre'
      },
      { icono: 'codigoqr.png',
        texto: 'servicioCodigoQr'
      },
      { icono: 'videovigilancia.png',
        texto: 'servicioVideoVigilancia'
      },
      { icono: 'alturamaxima.png',
        texto: 'servicioAlturaMaxima'
      },
      { icono: 'zbe.png',
        texto: 'servicioZbe'
      },
      { icono: 'plazasminusvalidos.png',
        texto: 'servicioPlazasMinusvalidos'
      },
  
    ], // fin array data.serviciosParking

    lugaresInteres: [
      { nombre:'puertobarcelona', 
        direccion:'direccionpuerto', 
        tiempoAPie: '0', 
        imagen: 'puerto-de-barcelona.jpg', 
        enlace:'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/41.3571442,2.1789423/@41.3572355,2.1787736,18.21z/data=!4m9!4m8!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m0!3e2'
      }, 
      { nombre: 'palaciovirreina', 
        direccion: 'direccionpalacio', 
        tiempoAPie: '46', 
        imagen: 'palacio-de-la-virreina.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Palacio+de+la+Virreina,+Barcelona/@41.3700389,2.159406,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2f64f4d98f1:0x6c3672a6a9c98a04!2m2!1d2.1712553!2d41.3824077!3e2'
      }, 
      { nombre:'teatroliceo', 
        direccion:'direccionteatro', 
        tiempoAPie: '42', 
        imagen: 'gran-teatro-del-liceo.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Gran+Teatre+del+Liceu,+La+Rambla,+Barcelona/@41.369075,2.1604029,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2580540cc5b:0xa05d8e0a1059639d!2m2!1d2.1732948!2d41.3801969!3e2'
      }, 
      { nombre:'larambla', 
        direccion:'direccionrambla', 
        tiempoAPie: '41', 
        imagen: 'la-rambla.jpg', 
        enlace:'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/La+Rambla,+Barcelona/@41.3689445,2.1608176,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a258081714c9:0x24bef7ac8842bdc4!2m2!1d2.1737903!2d41.3807484!3e2'
      }, 
      { nombre: 'boqueria', 
        direccion:  'direccionboqueria', 
        tiempoAPie: '46', 
        imagen: 'mercado-de-la-boqueria.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Mercado+de+La+Boqueria,+La+Rambla,+Barcelona/@41.3700389,2.159406,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a2f7b51e5a01:0x860ac654dc73add5!2m2!1d2.1715853!2d41.3817399!3e2'
      }, 
      { nombre:'plazareal', 
        direccion:'direccionplazareal', 
        tiempoAPie: '40', 
        imagen: 'plaza-real.jpg', 
        enlace: 'https://www.google.es/maps/dir/Passeig+de+l\'Escullera,+08039+Barcelona/Plaza+Real,+Pla%C3%A7a+Reial,+Barcelona/@41.3687634,2.1612372,14z/data=!3m1!4b1!4m14!4m13!1m5!1m1!1s0x12a4a24b057d0045:0xba3d039f85f80cfd!2m2!1d2.1789417!2d41.3571433!1m5!1m1!1s0x12a4a257e581f057:0x2859f63a8fc93e31!2m2!1d2.17527!2d41.3801!3e2'
      }    
    ], // fin array data.lugaresInteres

    tarifaParking: {
      tarifa: null,
      hayTarifa: false,
      cargada: false,
      hayError: false,  
      elError: null    
    }, // fin objeto data.tarifaparking

    tarifaParkingHoras: {
      tarifa: null,
      hayTarifa: false,
      cargada: false,
      hayError: false,  
      elError: null    
    }, // fin objeto data.tarifaParkingHoras

    tarifaParkingDiaPorHoras: {
      tarifa: null,
      hayTarifa: false,
      cargada: false,
      hayError: false,  
      elError: null    
    }, // fin objeto data.tarifaParkingDiaPorHoras

    datosReserva: {
      importeReserva: "",
      importeReservaNumero: 0,
      horaEntrada: "00:00",
      fechaEntrada: null,
      horaSalida: "00:00",
      fechaSalida: null,
      matricula: "",
      modelo: "",
      color: "",
      crucero: "",
      nombre: "",
      mail: "",
      telefono: "",
      cif: "",
      aceptacionTerminos: false
    }, // fin objeto data.datosReserva 

    submitted: false,

    traduccionDatepicker: {
      en: en,
      fr: fr,
      ca: ca,
      es: es
    }, // fin objeto data.traduccionDatepicker

    // ahora se obtienen de la base de datos
    cruceros: null, // fin array cruceros

    fechaMinimaEntrada: {
      to: ''
    }, // fin fechaMinimaEntrada
    
    fechaMaximaSalida: {
      to: '', 
      from: ''
    }, // fin fechamaximaSalida

    alerta: {
      mostrar: false,
      texto: ''
    }, //fin objeto alerta

    alertaTarifa: {
      mostrar: true,
      texto: ''
    }, //fin objeto alertaTarifa

    dialog: false,
    alertaDisponibilidad: {
      mostrar: false,
      texto: ''
    }, //fin objeto alerta

  }), // fin objeto data

  validations: {
          datosReserva: {
                fechaEntrada: { required },
                fechaSalida: { required },
                matricula: { required, alphaNum },
                modelo: { required },
                color: { },
                crucero: { }
            }
// un campo a validar
  },  // validacion de formularios con vuelidation

  methods:{
   abrirSelectorFechaEntrada: function() {
      escribirLog("abrir");
      this.$refs.fechaEntrada.showCalendar()
    }, // fin metodo abrirSelectorFechaEntrada

    abrirSelectorFechaSalida: function() {
      escribirLog("abrir");
      this.$refs.fechaSalida.showCalendar()
    },  // fin metodo abrirSelectorFechaSalida

    abrirSelectorHoraSalida: function() {
      escribirLog("abrir");
      this.$refs.horaSalida.toggleDropdown();
    },  // fin metodo abrirSelectorFechaSalida

    abrirSelectorHoraEntrada: function() {
      escribirLog("abrir");
      this.$refs.horaEntrada.toggleDropdown();
    },  // fin metodo abrirSelectorFechaSalida

    calcularImporteEstancia: function () {
      this.alertaDisponibilidad.mostrar = false;
      
      escribirLog("hay tarifa");
      escribirLog(this.tarifaParking);

      if (false == this.tarifaParking.hayTarifa){
        this.datosReserva.importeReserva = '----';
        return
      }

      escribirLog("He pasado");

      var textoError= '';

      /* combina los valores del datepicker y timepicker en un solo objeto moment y actualiza 
        la variable de datosReserva*/
      
      //fecha de entrada
      var hentrada = this.$moment('2020-01-01T' + this.datosReserva.horaEntrada + ':00');
      var fentrada = this.$moment(this.datosReserva.fechaEntrada).set(
                     {
                      "hour": hentrada.hour(), 
                      "minute": hentrada.minute(),
                      "second": 0,
                      "millisecond": 0
                    });
      this.datosReserva.fechaEntrada = fentrada.toDate();
      
      // no se pueden realizar reservas para el mismo dia que empiecen 
      // mas de dos horas antes del instante inicial
      var ahora = this.$moment();
      var duracion = this.$moment.duration(ahora.diff(fentrada));
      var horas = duracion.asHours();

      if (horas >= 2) {
        this.datosReserva.importeReserva = '----';
        textoError = this.$t('horaInicialErronea');

        this.alerta.mostrar = true;
        this.alerta.texto = textoError; 
        return;
      }

      var dias = Math.abs(duracion.asDays());
      escribirLog ('dias hasta inicio: ' + dias);
      if (dias >= 183) {
        this.datosReserva.importeReserva = '----';
        textoError = this.$t('superadaAntelacionMaxima');

        this.alerta.mostrar = true;
        this.alerta.texto = textoError; 
        return;
      }



      // fecha de salida
      var hsalida = this.$moment('2020-01-01T' + this.datosReserva.horaSalida + ':00');
      var fsalida = this.$moment(this.datosReserva.fechaSalida).set(
                     {
                      "hour": hsalida.hour(), 
                      "minute": hsalida.minute(),
                      "second": 0,
                      "millisecond": 0
                    });
      this.datosReserva.fechaSalida = fsalida.toDate();

      // calcula el numero de dias de duracion de la reserva
      var numeroDias = Math.ceil(fsalida.diff(fentrada, 'days', true));

      // solo se acepta estancias de 1 á 14 dias (lo establecido en la tarifa)
      if ((numeroDias > 0 ) && (numeroDias <15)) {
        this.alerta.mostrar = false;
        this.datosReserva.importeReserva = this.tarifaParking.tarifa[numeroDias - 1].printable_total_amount;
        this.datosReserva.importeReservaNumero = this.tarifaParking.tarifa[numeroDias - 1].total_amount;

      } else {

        this.datosReserva.importeReserva = '----';

        if (numeroDias <= 0 ) {
          textoError = this.$t('fechaFinalErronea');
        }

        if (numeroDias > 14 ) {
          textoError = this.$t('reservaMayorPermitido');
        }

        this.alerta.mostrar = true;
        this.alerta.texto = textoError; 

//        alert(textoError);

      }
      
      escribirLog ('fecha inicial       : ' + fentrada.toDate());
      escribirLog ('fecha final         : ' + fsalida.toDate());				
      escribirLog ('dias entre fechas   : ' + numeroDias);
      escribirLog ('Importe: ' + this.datosReserva.importeReserva);


    }, // fin metodo calcularImporteEstancia
    


    establecerFechaDatepicker: function (){
      /* establezco las fechas de los datepickers:
        - fecha de entrada (mañana).
        - fecha minima de entrada (mañana).
        - fecha de salida (pasado mañana).
        - fecha máxima de salida (14 dias desde mañana).
      */      

      /// reserva completamente nueva. Genero las fechas para los datepickers
      //var ahora = this.$moment().set({"hour": 10, "minute": 0}).toDate();
      var ahora = this.$moment();
      var ahoraDate = ahora.toDate();
      //escribirLog('ahora: ' + ahora);

      //mañana  
      var manana = this.$moment(ahoraDate).add(1, 'days').toDate();
      //var manana = this.$moment(ahora).add(1, 'days').toDate();
      //escribirLog('manana: ' + manana);
      
      /*var hora;
      if(ahora.hour() < 10) {
        hora = '0' + ahora.hour() + ':00';
      } else {   
        hora = '0' + ahora.hour() + ':00';
      }*/

      // un dia de plazo para iniciar la reserva
      this.datosReserva.fechaEntrada = ahoraDate;  
      // no puedo realizar reservas anteriores a hoy
      this.fechaMinimaEntrada.to = this.$moment(ahoraDate).toDate();
      // selecciono la hora actual para el timepicker
      this.datosReserva.horaEntrada = '11:00';

      // la reserva dura al menos un dia
      this.datosReserva.fechaSalida = manana; 
      // no puedo terminar la reserva antes de pasado mañana
      this.fechaMaximaSalida.to = this.fechaMinimaEntrada.to
      // selecciono la hora actual para el timepicker
      this.datosReserva.horaSalida = '11:00';
           
    }, // fin metodo establecerFechaDatepicker 

    establecerIdiomaDatepicker: function (){
      var elIdioma;

      switch(window.localStorage.getItem("idioma")) {
      case 'es':
        elIdioma = this.traduccionDatepicker.es;
        break;
      case 'en':
        elIdioma = this.traduccionDatepicker.en;
        break;
      case 'fr':
        elIdioma = this.traduccionDatepicker.fr;
        break;
      case 'ca':
        elIdioma = this.traduccionDatepicker.ca;
        break;
      default:
        elIdioma = this.traduccionDatepicker.es;
      }

      return elIdioma;
    },  // fin metodo establecerIdiomaDatepicker


    obtenerDisponibilidadPlaza: function(){
      var parametros= {
        'idaparcamiento': this.id_parking,
        'codinsclo': this.codinsclo,        
        'id_parking': codinsclo,
        'activation': this.$moment(this.datosReserva.fechaEntrada).toISOString(),
        'expiry': this.$moment(this.datosReserva.fechaSalida).toISOString(),
        'zonareservas': 'Reservas',
        'matricula': this.datosReserva.matricula
      };

      const cabeceras = {
      };

      axios
        .get(generarUrlBase() + '/restapi/EPCloud/obtenerDisponibilidadPlazas', 
              { params: parametros,
                headers:cabeceras
              })
        .then(response => {
          escribirLog('Respuesta obtenerDisponibilidadPlaza');
          escribirLog(response);
          this.alertaDisponibilidad.mostrar = false;
          this.dialog = false;
           

          escribirLog(response.data.available_places);
          escribirLog(response.data.availability_request_expire_time);
          
          if (response.data.available_places > 0){
            escribirLog('Hay plazas disponibles')
            
            // salvamos los datos de la reserva en localStorage       
            window.localStorage.setItem("importeReserva", this.datosReserva.importeReserva);
            window.localStorage.setItem("importeReservaNumero", this.datosReserva.importeReservaNumero);
            // las fechas de entrada/salida incluyen la informacion de la hora
            window.localStorage.setItem("fechaEntrada", this.datosReserva.fechaEntrada);
            window.localStorage.setItem("fechaSalida", this.datosReserva.fechaSalida);
            window.localStorage.setItem("horaEntrada", this.datosReserva.horaEntrada);
            window.localStorage.setItem("horaSalida", this.datosReserva.horaSalida);

            window.localStorage.setItem("matricula", this.datosReserva.matricula);
            window.localStorage.setItem("modelo", this.datosReserva.modelo);
            window.localStorage.setItem("color", this.datosReserva.color);
            window.localStorage.setItem("crucero", this.datosReserva.crucero);
      
            window.localStorage.setItem("availability_request_token", response.data.availability_request_token);      
            window.localStorage.setItem("availability_request_expiration_time", response.data.availability_request_expire_time);      
            
            // cambio de pagina
            this.$router.push({ path: '/continuarReserva' })

          } else {
            escribirLog('NO hay plazas disponibles')
            this.alertaDisponibilidad.mostrar = true;
            this.alertaDisponibilidad.texto = this.$t('plazasNoDiponibles'); /*+ 
                                              response.data.disponibilidad.datos.error_message;*/
          }
            
        })
        .catch(error => {
          escribirLog('Error obtenerDisponibilidadPlaza')
          escribirLog(error);

          this.dialog = false;
          this.alertaDisponibilidad.mostrar = true;
          this.alertaDisponibilidad.texto = this.$t('errorObteniendoDisponibilidad')

        })
        .finally(() => { 
          escribirLog('Final obtenerDisponibilidadPlaza');
        })
    }, // fin metodo ObtenerDisponibilidadPlaza




    handleSubmit() {
      /* comprobacion de que los datos del formulario son correctos 
        antes de continuar con el proceso de reserva */

        if (false == this.tarifaParking.hayTarifa) {
          return;
        }

        this.submitted = true;

        // convierto la matricula a mayusculas
        this.datosReserva.matricula = this.datosReserva.matricula.toUpperCase();
        escribirLog(this.datosReserva.matricula);


        escribirLog(this.datosReserva);

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
 
        if (true == this.alerta.mostrar) {
          return;
        }
      
        // muestra indicador espera
        this.dialog = true;
        // antes de continuar con la reserva hay que comprobar si hay plazas disponibles
        this.obtenerDisponibilidadPlaza();

    },  // fin metodo handleSubmit

    cadenaTiempo: function (aTiempo){
      return aTiempo + " " + this.$t('minutos');
    }, // fin metodo cadenaTiempo

    cadenaDuracion: function (aDuracionReserva){
      aDuracionReserva += 1; 
      
      if (1 == aDuracionReserva) {
        return aDuracionReserva + " " + this.$t('dia');
      }
      else {  
        return aDuracionReserva + " " + this.$t('dias');
      }  
    }, // fin metodo cadenaDuracion


    callback_tablaTarifaDias: function(response){
      this.tarifaParking.tarifa = response.data.availability_array;
      this.tarifaParking.hayTarifa = true;
      this.calcularImporteEstancia();
      this.tarifaParking.cargada = true 
      this.alertaTarifa.mostrar = false;
      this.alertaTarifa.texto = '';
    }, // fin metodo callback_tablaTarifaDias

    callback_tablaTarifaHoras: function(response){
      this.tarifaParkingHoras.tarifa = response.data.availability_array;
      this.tarifaParkingHoras.hayTarifa = true;
      this.tarifaParkingHoras.cargada = true 
    }, // fin metodo callback_tablaTarifaHoras

    callback_tarifaDiaPorHoras: function(response){
      escribirLog(response.data.availability_array);
      this.tarifaParkingDiaPorHoras.tarifa = response.data.availability_array;
      this.tarifaParkingDiaPorHoras.hayTarifa = true;
      this.tarifaParkingDiaPorHoras.cargada = true 
    }, // fin metodo callback_tarifaDiaPorHoras


    obtenerTablaTarifa: function(idParking, tipoProducto, numeroPeriodos, unidad, callback){
      escribirLog('Consulta ObtenerTablaTarifa');
      var parametros= {
        'id_parking': idParking,
        'tipo_producto': tipoProducto,
        'numero_unidades': numeroPeriodos,
        'unidad': unidad
      };

      const cabeceras = {
      };

      axios
        .get(generarUrlBase() + '/restapi/EPCloud/obtenerTablaTarifaEstacionamiento', 
              { params: parametros,
                headers:cabeceras
              })
        .then(response => {
          escribirLog('Respuesta ObtenerTablaTarifa');
          callback(response);
        })
    }, // fin metodo ObtenerTablaTarifa
  


    obtenerListaCruceros: function(){

      escribirLog('Consulta obtenerListaCruceros');
      var parametros= {
      };

      const cabeceras = {
      };

      axios
        .get(generarUrlBase() + '/restapi/BD/obtenerListaCruceros', 
              { params: parametros,
                headers:cabeceras
              })
        .then(response => {
          escribirLog('Respuesta ObtenerReserva');
          this.cruceros = response.data.cruceros;
          this.datosReserva.crucero = this.cruceros[0];

          escribirLog(response);
        })
        .catch(error => {
          escribirLog('Error obtenerListaCruceros');
          escribirLog(error);
        })
        .finally(() => { 
          escribirLog('Final obtenerListaCruceros');
        })

    }, // fin metodo obtenerListaCruceros  

  }, // fin methods


  mounted () {
    // consulto al parking por su tarifa
    this.obtenerTablaTarifa(codinsclo, 1, 2, 'hora', this.callback_tablaTarifaHoras);
    this.obtenerTablaTarifa(codinsclo, 2, 14, 'dia', this.callback_tablaTarifaDias);
    this.obtenerTablaTarifa(codinsclo, 1, 25, 'hora', this.callback_tarifaDiaPorHoras);
    this.obtenerListaCruceros();

      // Carga de los datos de localStorage
    this.datosReserva.importeReserva = window.localStorage.getItem("importeReserva");
    this.datosReserva.importeReservaNumero = window.localStorage.getItem("importeReservaNumero");
    this.datosReserva.fechaEntrada = window.localStorage.getItem("fechaEntrada");
    this.datosReserva.fechaSalida = window.localStorage.getItem("fechaSalida");
   
    this.datosReserva.horaSalida = window.localStorage.getItem("horaSalida");
    this.datosReserva.horaEntrada = window.localStorage.getItem("horaEntrada");
    
    this.datosReserva.matricula = window.localStorage.getItem("matricula");
    this.datosReserva.modelo = window.localStorage.getItem("modelo");
    this.datosReserva.color = window.localStorage.getItem("color");
    this.datosReserva.crucero = window.localStorage.getItem("crucero");

    escribirLog("datos Reserva en memoria");
    escribirLog(this.datosReserva);

    /* establezco las fechas de los datepickers:
      - fecha de entrada (mañana).
      - fecha minima de entrada (mañana).
      - fecha de salida (pasado mañana).
      - fecha máxima de salida (14 dias desde mañana).
    */
    
    if ((false == this.$moment(this.datosReserva.fechaEntrada).isValid()) || 
        (false == this.$moment(this.datosReserva.fechaSalida).isValid())){
      escribirLog("establecerFechaDatepicker");    
      this.establecerFechaDatepicker();
    }

        
    window.scrollTo(0,0);

  },
   // fin evento mounted  

};
</script>
